import { IDeleteInspecaoObraUseCase } from "../../../presentation/useCases/delete/delete_inspecao_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteInspecaoObraUseCase
 */

export class DeleteInspecaoObraUseCase implements IDeleteInspecaoObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteInspecaoObra(
    idInspecaoObra: number,
  ): Promise<void> {
    await this.repository.deleteInspecaoObra(
      idInspecaoObra,
    );
  }
}
